const STORAGE_FOLDERS = {
  APPLICATION_LOGOS: 'Application-logos'
}

export default STORAGE_FOLDERS
